export const isLateNightRequired = ({ loan_fee, rental_time_in_minutes_from, rental_time_in_minutes_to }) => {
  return loan_fee || rental_time_in_minutes_from || rental_time_in_minutes_to
}
